import { Component, OnInit } from '@angular/core';
import { ConfirmDialogModel } from '../../../models/generc_dialogs/confirmDialogModel';
import { MdDialogRef } from '@angular/material';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.css']
})
export class ConfirmDialogComponent implements OnInit {
  confirmDescriptor:ConfirmDialogModel;
  result:boolean=false;
  constructor( public dialogRef: MdDialogRef<ConfirmDialogComponent>, dm:ConfirmDialogModel) { 
    this.confirmDescriptor=dm;
    if(!this.confirmDescriptor.text) {
      this.confirmDescriptor.text = "Procedere con l'operazione?";
    }
  }

  ngOnInit() {
    
  }
  okButtonClick() {
    this.dialogRef.close(true);
  }
  annullaButtonClick() {
    this.dialogRef.close(false);
  }

}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/generic_dialogs/confirm-dialog/confirm-dialog.component.ts